import React from "react";
import NavPills from "components/NavPills/NavPills.jsx";
import Usuario from "views/Catalogos/Usuarios.jsx";
import Roles from "views/Catalogos/Roles.jsx";

export default function Catalogos() {
  return (
    <div>
      <NavPills
        color="info"
        tabs={[
          {
            tabButton: "Usuarios",
            tabContent: <Usuario />
          },
          {
            tabButton: "Roles",
            tabContent: <Roles />
          }
        ]}
      />
    </div>
  );
}
